import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import './SellerTerms.css';

const SellerTerms = () => {
  const { userId } = useParams();
  const navigate=useNavigate();
  const [agreed, setAgreed] = useState(false);

  const handleBacktoAdd=()=>{
    navigate(`/addproduct/${userId}`);
  }

  return (
    <div className="terms-container">
      <div className="terms-header">
        <h1>Seller Terms & Conditions</h1>
        <p className="subtitle">
          By posting products on bridgenapp.com, you agree to the following terms:
        </p>
      </div>

      <div className="terms-content">

        {/* Free Trial */}
        <section className="term-section">
          <div className="term-card">
            <div className="term-icon">🎁</div>
            <h3>Free Trial Period</h3>
            <p>
              All new sellers enjoy a <strong>1 month free trial</strong>.
              After this period, standard subscription fees will apply.
            </p>
          </div>
        </section>

        {/* Inventory */}
        <section className="term-section">
          <div className="term-card">
            <div className="term-icon">📦</div>
            <h3>Product Inventory</h3>
            <p>
              You may only post products that you <strong>currently have in stock</strong>.
              Listings must be removed immediately when items are no longer available.
            </p>
          </div>
        </section>

        {/* Payment */}
        <section className="term-section">
          <div className="term-card">
            <div className="term-icon">💳</div>
            <h3>Payment Handling</h3>
            <p>
              All payments are processed via the platform (Mpesa: <strong>58450600 Lipa Bridgenapp</strong>)
              and later disbursed to you. Direct payments outside the platform are strictly prohibited for the safety of shoppers funds
              except for nearby buyers who can appear physically at your store/service.
            </p>
          </div>
        </section>

        {/* Verification */}
        <section className="term-section">
          <div className="term-card">
            <div className="term-icon">🔍</div>
            <h3>Product Verification</h3>
            <p>Our <strong>verified local agents</strong> will collect purchased items and verify that:</p>
            <ul>
              <li>Products match descriptions</li>
              <li>Items are in stated condition</li>
              <li>Quantities are accurate</li>
            </ul>
          </div>
        </section>

        {/* Fulfillment */}
        <section className="term-section">
          <div className="term-card">
            <div className="term-icon">🚚</div>
            <h3>Order Fulfillment</h3>
            <p>
              Sellers must ensure products are ready for pickup immediately after purchase.
              Delays may result in penalties or suspension.
            </p>
          </div>
        </section>

        {/* Returns */}
        <section className="term-section">
          <div className="term-card">
            <div className="term-icon">🔄</div>
            <h3>Returns & Refunds</h3>
            <p>
              If a product fails verification or does not meet expectations,
              sellers must accept returns and refunds as determined by the platform.
            </p>
          </div>
        </section>

        {/* Listing Accuracy */}
        <section className="term-section">
          <div className="term-card">
            <div className="term-icon">📸</div>
            <h3>Listing Accuracy</h3>
            <p>
              All listings must include accurate descriptions and images.
              Misleading or false information is strictly prohibited.
            </p>
          </div>
        </section>

        {/* Pricing */}
        <section className="term-section">
          <div className="term-card">
            <div className="term-icon">🏷️</div>
            <h3>Pricing Policy</h3>
            <p>
              Sellers must provide fair and transparent pricing.
              Artificial inflation or misleading discounts are not allowed.
            </p>
          </div>
        </section>

        {/* Fees */}
        <section className="term-section">
          <div className="term-card">
            <div className="term-icon">💰</div>
            <h3>Selling Fees</h3>
            <p>
              Each successful sale will incur a <strong>5% to 8% platform fee,</strong>
              calculated based on the sale price.
            </p>
          </div>
        </section>

        {/* Ratings */}
        <section className="term-section">
          <div className="term-card">
            <div className="term-icon">⭐</div>
            <h3>Ratings & Reviews</h3>
            <p>
              Sellers will be rated by customers. Poor ratings may lead to account suspension.
            </p>
          </div>
        </section>

        {/* Cancellation */}
        <section className="term-section">
          <div className="term-card">
            <div className="term-icon">⏱️</div>
            <h3>Order Cancellations</h3>
            <p>
              Sellers are not allowed to cancel confirmed orders without valid reasons.
              Frequent cancellations may lead to penalties.</p>
          </div>
        </section>

        {/* Prohibited */}
        <section className="term-section">
          <div className="term-card">
            <div className="term-icon">⛔</div>
            <h3>Prohibited Items</h3>
            <p>
              Illegal, counterfeit, stolen, or unsafe products are strictly prohibited.
            </p>
          </div>
        </section>

        {/* Communication */}
        <section className="term-section">
          <div className="term-card">
            <div className="term-icon">💬</div>
            <h3>Communication Policy</h3>
            <p>
              Sellers must communicate with buyers only through the platform
              and must not attempt to redirect transactions outside Bridgenapp.
            </p>
          </div>
        </section>

        {/* Tax */}
        <section className="term-section">
          <div className="term-card">
            <div className="term-icon">🧾</div>
            <h3>Tax Compliance</h3>
            <p>
              Sellers are responsible for complying with all applicable tax laws and regulations.
            </p>
          </div>
        </section>

        {/* Account */}
        <section className="term-section">
          <div className="term-card">
            <div className="term-icon">🔐</div>
            <h3>Account Responsibility</h3>
            <p>
              Sellers are responsible for securing their account and all activities under it.
            </p>
          </div>
        </section>

        {/* Compliance Warning */}
        <section className="term-section warning-section">
          <div className="term-card warning-card">
            <div className="term-icon">⚠️</div>
            <h3>Compliance</h3>
            <p><strong>Failure to comply</strong> with these terms will result in</p>
            <ul>
              <li>Immediate uspension of your seller account</li>
              <li>Withholding of pending payments</li>
              <li>Permanent ban for repeated violations</li>
            </ul>
          </div>
        </section>

        {/* Agreement */}
        <div className="acknowledgement">
          <div className="checkbox-container">
            <input
              type="checkbox"
              id="agree-terms"
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
            />
            <label htmlFor="agree-terms">
              I have read and agree to the Terms & Conditions
            </label>
          </div>

          <button
            className="accept-btn"
            disabled={!agreed}
            style={{ opacity: agreed ? 1 : 0.5, cursor: agreed ? 'pointer' : 'not-allowed' }}
            onClick={handleBacktoAdd}
          >
            Accept & Continue
          </button>
        </div>

      </div>
    </div>
  );
};

export default SellerTerms;